<template>
  <nx-auth-card
    :title="$t('message.login.secondFactor.title')"
    v-on="$listeners"
  >
    <ds-text>
      {{ $t('message.login.secondFactor.description') }}
    </ds-text>
    <ds-text>
      {{ $t('message.login.secondFactor.description2') }}
    </ds-text>

    <nx-form
      ref="form"
      @form="form = $event"
      @submit.prevent="submit"
    >
      <nx-form-text
        v-model="otp"
        :label="$t('message.form.fields.otp')"
        append-icon="password"
        autofocus
        mask="### ###"
        name="otp"
        validation="required|second_factor_otp"
      />
      <v-btn
        :disabled="form.invalid || form.pristine"
        :loading="loading"
        block
        color="secondary"
        type="submit"
      >
        {{ $t('message.login.secondFactor.verify') }}
      </v-btn>
    </nx-form>
  </nx-auth-card>
</template>

<script>
import { mapState } from 'vuex';
import NxFormText from '@/modules/form/components/FormText.vue';
import NxForm from '@/modules/form/Form.vue';
import NxAuthCard from '@/modules/authentication/components/AuthCard.vue';
import { LOGIN_PAGE_ID_LOGIN } from '@/modules/authentication/config/login-routes';
import AuthComponent from '@/modules/authentication/mixins/auth-component';

export default {
  name: 'NxAuthSecondFactorLogin',
  components: {
    NxAuthCard,
    NxForm,
    NxFormText,
  },
  mixins: [AuthComponent],
  data() {
    return {
      otp: '',
      form: {},
    };
  },
  computed: {
    ...mapState('authentication', ['secondFactorJwt']),
  },
  mounted() {
    if (!this.secondFactorJwt) {
      this.$emit('redirect', LOGIN_PAGE_ID_LOGIN);
    }
  },
  methods: {
    async submit() {
      if (this.loading) {
        return;
      }

      const result = await this.dispatch('authentication/SECOND_FACTOR_VERIFICATION', { otp: this.otp });
      if (!result.success) {
        await this.$nextTick();
        this.$refs.form.errors.add({
          field: 'otp',
          msg: this.$t('message.error.invalidSecondFactorOtp'),
        });
      }
    },
  },
};
</script>
